import { render, staticRenderFns } from "./EditorDocumentSettings.vue?vue&type=template&id=11e13cc2&"
import script from "./EditorDocumentSettings.vue?vue&type=script&lang=js&"
export * from "./EditorDocumentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports